import { z } from "../../../../../lib";
import { OperacionLCTCCacheFields, OperacionLCTCCuentaFields, OperacionLCTCCuentaLimiteFields, OperacionLCTCFields, OperacionLCTCLimiteAprobadoFields, OperacionLCTCLimitesAprobadosPaisFields, OperacionLCTCLimitesAprobadosUnidadNegocioFields, OperacionLCTCRelacionFields, OperacionLCTCSectorComercialFields, OperacionLCTCUnidadNegocioFields } from "./fields";
import { schemaEntityWithId, schemaEntityWithIdAndDescription } from "../../../../../types";

export const schemaOperacionLCTCCuentaInsert = z.object({
    [OperacionLCTCCuentaFields.CodClienteTipo]: z.number().nullable(),
    [OperacionLCTCCuentaFields.CodClienteSubTipo]: z.number().nullable(),
    [OperacionLCTCCuentaFields.LimiteConcertacion]: z.string(),
    [OperacionLCTCCuentaFields.LimiteLiquidacionDVP]: z.string().nullable().optional(),
    [OperacionLCTCCuentaFields.LimiteLiquidacionFOP]: z.string().nullable().optional(),
});
export type OperacionLCTCCuentaInsert = z.infer<typeof schemaOperacionLCTCCuentaInsert>;

export const schemaOperacionLCTCInsert = z.object({
    [OperacionLCTCFields.CodPais]: z.number(),
    [OperacionLCTCFields.CodUnidadNegocio]: z.number(),
    [OperacionLCTCFields.CodSectorComercial]: z.number(),
    [OperacionLCTCFields.FechaSolicitud]: z.date(),
    [OperacionLCTCFields.FechaVencimiento]: z.date(),
    [OperacionLCTCFields.Observaciones]: z.string().nullable().optional(),

    [OperacionLCTCFields.Cuentas]: z.array(schemaOperacionLCTCCuentaInsert),
});
export type OperacionLCTCInsert = z.infer<typeof schemaOperacionLCTCInsert>;

export const schemaOperacionLCTCCuentaLimiteUpdate = z.object({
    [OperacionLCTCCuentaFields.LimiteConcertacion]: z.string(),
    [OperacionLCTCCuentaFields.LimiteLiquidacionDVP]: z.string().nullable().optional(),
    [OperacionLCTCCuentaFields.LimiteLiquidacionFOP]: z.string().nullable().optional(),
});
export type OperacionLCTCCuentaLimiteUpdate = z.infer<typeof schemaOperacionLCTCCuentaLimiteUpdate>;

export const schemaOperacionLCTCLimiteTipo = z
    .object({

        [OperacionLCTCFields.Monto]: z.number(),
    })
    .merge(schemaEntityWithIdAndDescription)
export type OperacionLCTCLimiteTipo = z.infer<typeof schemaOperacionLCTCLimiteTipo>

export const schemaOperacionLCTCCuentaHistoriaDTO = z.object({
    [OperacionLCTCCuentaLimiteFields.CodGrupo]: z.number(),
    [OperacionLCTCCuentaLimiteFields.DescGrupo]: z.string(),
    [OperacionLCTCCuentaLimiteFields.LimiteConcertacion]: z.string(),
    [OperacionLCTCCuentaLimiteFields.LimiteLiquidacionDVP]: z.string().nullable(),
    [OperacionLCTCCuentaLimiteFields.LimiteLiquidacionFOP]: z.string().nullable(),
    [OperacionLCTCCuentaLimiteFields.FechaAccion]: z.coerce.date().nullable(),
    [OperacionLCTCCuentaLimiteFields.Etapa]: z.string(),
    [OperacionLCTCCuentaLimiteFields.OrdenCliente]: z.number(),
    [OperacionLCTCCuentaLimiteFields.OrdenSubCliente]: z.number(),
    [OperacionLCTCCuentaLimiteFields.UnidadNegocio]: z.string(),
    [OperacionLCTCCuentaLimiteFields.ClienteTipo]: z.string().nullable(),
    [OperacionLCTCCuentaLimiteFields.ClienteSubTipo]: z.string().nullable(),
}).merge(schemaEntityWithId);
export type OperacionLCTCCuentaHistoriaDTO = z.infer<typeof schemaOperacionLCTCCuentaHistoriaDTO>;

export const schemaOperacionLCTCCuentaVista = z.object({
    [OperacionLCTCCuentaFields.DescClienteTipo]: z.string().nullable(),
    [OperacionLCTCCuentaFields.DescClienteSubTipo]: z.string().nullable(),
    [OperacionLCTCCuentaLimiteFields.LimiteConcertacion]: z.string(),
    [OperacionLCTCCuentaLimiteFields.LimiteLiquidacionDVP]: z.string().nullable(),
    [OperacionLCTCCuentaLimiteFields.LimiteLiquidacionFOP]: z.string().nullable(),
    [OperacionLCTCCuentaLimiteFields.PermiteModificar]: z.boolean(),
}).merge(schemaEntityWithId);
export type OperacionLCTCCuentaVista = z.infer<typeof schemaOperacionLCTCCuentaVista>;


export const schemaOperacionLCTCClienteTipoSchema = z.object({
    [OperacionLCTCCacheFields.Orden]: z.number(),
}).merge(schemaEntityWithIdAndDescription);

export const schemaOperacionLCTCRelacionSchema = z.object({
    [OperacionLCTCRelacionFields.CodSectorComercial]: z.number(),
    [OperacionLCTCRelacionFields.CodClienteTipo]: z.number(),
    [OperacionLCTCRelacionFields.CodClienteSubTipo]: z.number(),
    [OperacionLCTCRelacionFields.DescClienteTipo]: z.string(),
    [OperacionLCTCRelacionFields.DescClienteSubTipo]: z.string(),
}).merge(schemaEntityWithId);

export type OperacionLCTCClienteTipo = z.infer<typeof schemaOperacionLCTCClienteTipoSchema>;
export type OperacionLCTCClienteSubTipo = z.infer<typeof schemaOperacionLCTCClienteTipoSchema>;
export type OperacionLCTCRelacion = z.infer<typeof schemaOperacionLCTCRelacionSchema>;


export const schemaOperacionLCTCLimiteAprobado = z.object({
    [OperacionLCTCLimiteAprobadoFields.CodPais]: z.number(),
    [OperacionLCTCLimiteAprobadoFields.CodSistema]: z.number(),
    [OperacionLCTCLimiteAprobadoFields.CodClienteTipo]: z.number(),
    [OperacionLCTCLimiteAprobadoFields.DescClienteTipo]: z.string(),
    [OperacionLCTCLimiteAprobadoFields.CodClienteSubTipo]: z.number().nullable().optional(),
    [OperacionLCTCLimiteAprobadoFields.DescClienteSubTipo]: z.string().nullable().optional(),
    
    [OperacionLCTCLimiteAprobadoFields.LimiteConcertacionFinal]: z.string(), 
    [OperacionLCTCLimiteAprobadoFields.LimiteLiquidacionDVPFinal]: z.string(),
    [OperacionLCTCLimiteAprobadoFields.LimiteLiquidacionFOPFinal]: z.string(),
    
    [OperacionLCTCLimiteAprobadoFields.Activo]: z.boolean(),
    [OperacionLCTCLimiteAprobadoFields.FechaAlta]: z.coerce.date(),
    [OperacionLCTCLimiteAprobadoFields.IdUsuarioAlta]: z.number(),
    [OperacionLCTCLimiteAprobadoFields.IdMensaje]: z.number(),
    [OperacionLCTCLimiteAprobadoFields.FechaAprobacion]: z.coerce.date().nullable(),
    [OperacionLCTCLimiteAprobadoFields.UsuarioUltMod]: z.string(),
    [OperacionLCTCLimiteAprobadoFields.NombreSistemaPrincipal]: z.string(),
    [OperacionLCTCLimiteAprobadoFields.CodSistemaPrincipal]: z.number(),
    [OperacionLCTCLimiteAprobadoFields.CodUnidadNegocio]: z.number(),
});

export type OperacionLCTCLimiteAprobado = z.infer<typeof schemaOperacionLCTCLimiteAprobado>;


export const schemaOperacionLCTCLimitesAprobadosUnidadNegocio = z.object({
    [OperacionLCTCLimitesAprobadosUnidadNegocioFields.CodUnidadNegocio]: z.number(),
    [OperacionLCTCLimitesAprobadosUnidadNegocioFields.DescUnidadNegocio]: z.string(),
    [OperacionLCTCLimitesAprobadosUnidadNegocioFields.ListaLimites]: z.array(schemaOperacionLCTCLimiteAprobado)
});

export type OperacionLCTCLimitesAprobadosUnidadNegocio = z.infer<typeof schemaOperacionLCTCLimitesAprobadosUnidadNegocio>;


export const schemaOperacionLCTCLimitesAprobadosPais = z.object({
    [OperacionLCTCLimitesAprobadosPaisFields.CodPais]: z.number(),
    [OperacionLCTCLimitesAprobadosPaisFields.NombrePais]: z.string(),
    [OperacionLCTCLimitesAprobadosPaisFields.FechaUltMod]: z.coerce.date(),
    [OperacionLCTCLimitesAprobadosPaisFields.UsuarioUltMod]: z.string(),
    [OperacionLCTCLimitesAprobadosPaisFields.IdMensaje]: z.number(),
    [OperacionLCTCLimitesAprobadosPaisFields.FechaAprobacion]: z.coerce.date().nullable(),
    [OperacionLCTCLimitesAprobadosPaisFields.ListaUnidadesNegocio]: z.array(schemaOperacionLCTCLimitesAprobadosUnidadNegocio)
});

export type OperacionLCTCLimitesAprobadosPais = z.infer<typeof schemaOperacionLCTCLimitesAprobadosPais>;

export const schemaListaOperacionLCTCLimitesAprobadosPais = z.array(schemaOperacionLCTCLimitesAprobadosPais);


export const schemaOperacionLCTCUnidadNegocio = z
    .object({

        [OperacionLCTCUnidadNegocioFields.CodUnidadNegocio]: z.number(),
    })
    .merge(schemaEntityWithIdAndDescription)
export type OperacionLCTCUnidadNegocio = z.infer<typeof schemaOperacionLCTCUnidadNegocio>

export const schemaOperacionLCTCSectorComercial = z
    .object({

        [OperacionLCTCSectorComercialFields.CodSectorComercial]: z.number(),
    })
    .merge(schemaEntityWithIdAndDescription)
export type OperacionLCTCSectorComercial = z.infer<typeof schemaOperacionLCTCSectorComercial>